import { format, parseISO } from 'date-fns';
import { Slots, TimeSlots } from '../services/Appointment/model';
import { SlotsObjects } from '../reducers/timeslots/timeSlotsTypes';

export function getTimeSlotById(
  slots: Slots[],
  id?: string,
): TimeSlots | undefined {
  if (!id) return undefined;

  let time;
  for (let i = 0; i < slots.length; i += 1) {
    const slot = slots[i];
    for (
      let innerIndex = 0;
      innerIndex < slot.timeSlots.length;
      innerIndex += 1
    ) {
      const timeSlot = slot.timeSlots[innerIndex];
      if (id === timeSlot.id) {
        time = timeSlot;
        break;
      }
    }
  }

  return time;
}

export function getFirstAvailableTimeSlot(
  slots: Slots[],
): TimeSlots | undefined {
  const slot = slots.length > 0 ? slots[0] : undefined;
  return slot ? slot.timeSlots[0] : undefined;
}

export const getSelectedTimeSlot = (
  slots: Slots[],
  from: string,
  id?: string,
): { date: string; id: string } => {
  const selectedTimeSlot = getTimeSlotById(slots, id);

  if (selectedTimeSlot) {
    return {
      date: selectedTimeSlot.dateFrom as string,
      id: selectedTimeSlot.id as string,
    };
  }

  const prebooked = getFirstAvailableTimeSlot(slots);

  if (prebooked) {
    return {
      date: prebooked.dateFrom as string,
      id: prebooked.id as string,
    };
  }
  if (from) {
    return {
      date: format(parseISO(from), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
      id: '',
    };
  }

  return {
    date: '',
    id: '',
  };
};

export const timeSlotExtractor = (
  timeSlots: SlotsObjects,
  timeSlotId: string,
  storeId: string,
): TimeSlots | undefined => {
  const allTimeSlotsOnGivenDate = timeSlots[storeId].find((slots) =>
    slots.timeSlots.some((slot) => slot.id === timeSlotId),
  );
  return allTimeSlotsOnGivenDate?.timeSlots.find(
    (slot) => slot.id === timeSlotId,
  );
};
